import { render, staticRenderFns } from "./UpdateDrugBatch.vue?vue&type=template&id=7f3b49cd&scoped=true&lang=pug&"
import script from "./UpdateDrugBatch.vue?vue&type=script&lang=ts&"
export * from "./UpdateDrugBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3b49cd",
  null
  
)

export default component.exports